(() => {
  'use strict';

  if (window.ArtboxCartExperience) window.ArtboxCartExperience.destroy();

  const drawer = document.querySelector('#t4s-mini_cart');
  let editor = null;
  let editorContent = null;
  let list = null;
  const state = { successPending: false, editorActive: false, editorTrigger: null, editorImageTop: null, editorColorId: null, lastBagOpener: null, openCount: 0, pendingAdd: null, checkoutPending: false, checkoutTriggered: false, checkoutOverlayOpen: false, inputMode: 'pointer' };
  let staleTimer = 0;
  let drawerObserver = null;
  let checkoutObserver = null;
  let checkoutTimer = 0;
  let overlayObserver = null;
  let overlayDiscoveryObserver = null;
  let editorLabelObserver = null;
  let bagHeightFrame = 0;
  let bagHeightTimer = 0;

  function canAnimateBagHeight() {
    return drawer && window.matchMedia('(min-width: 768px)').matches && drawer.getAttribute('aria-hidden') === 'false';
  }

  function freezeBagHeight() {
    if (!canAnimateBagHeight()) return;
    window.cancelAnimationFrame(bagHeightFrame);
    window.clearTimeout(bagHeightTimer);
    drawer.style.height = `${drawer.getBoundingClientRect().height}px`;
  }

  function animateBagHeight() {
    if (!canAnimateBagHeight()) return;
    const start = drawer.getBoundingClientRect().height;
    drawer.style.height = 'auto';
    const target = drawer.getBoundingClientRect().height;
    drawer.style.height = `${start}px`;
    drawer.getBoundingClientRect();
    bagHeightFrame = window.requestAnimationFrame(() => {
      drawer.style.height = `${target}px`;
      bagHeightTimer = window.setTimeout(() => {
        drawer.style.height = '';
        bagHeightTimer = 0;
      }, 320);
    });
  }

  function refreshBagNodes() {
    editor = drawer?.querySelector('[data-artbox-bag-editor]') || null;
    editorContent = editor?.querySelector('[data-artbox-bag-editor-content]') || null;
    list = drawer?.querySelector('[data-artbox-cart-list]') || null;
  }

  const isVisible = (element) => Boolean(element && element.getClientRects().length);

  function notePointerInput() {
    state.inputMode = 'pointer';
  }

  function noteKeyboardInput(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    state.inputMode = 'keyboard';
  }

  function captureBagOpener(event) {
    const opener = event.target.closest?.('[data-drawer-options*="#t4s-mini_cart"]');
    if (opener && isVisible(opener)) state.lastBagOpener = opener;
  }

  function openBag() {
    if (!drawer || drawer.getAttribute('aria-hidden') === 'false') return;
    const opener = [...document.querySelectorAll('[data-drawer-options*="#t4s-mini_cart"]')].find(isVisible);
    if (!opener) return;
    state.lastBagOpener = opener;
    state.openCount += 1;
    opener.click();
    // Kalles can ignore a synthetic click while another drawer is finishing
    // its close animation. Verify the real drawer state before giving up.
    if (drawer.getAttribute('aria-hidden') === 'false') return;
    window.requestAnimationFrame(() => {
      if (drawer.getAttribute('aria-hidden') === 'false') return;
      const nativeDrawer = window.T4SThemeSP?.Drawer;
      if (nativeDrawer?.opend && window.jQuery_T4NT) {
        nativeDrawer.opend(window.jQuery_T4NT(drawer));
      }
    });
  }

  function openBagAfterAdd() {
    if (!state.editorActive) {
      const quickShop = document.querySelector('.t4s-modal [data-artbox-quick-shop]');
      if (isVisible(quickShop)) quickShop.closest('.t4s-modal')?.querySelector('[data-t4s-modal-close], .t4s-modal-close')?.click();
    }
    openBag();
  }

  function markAddSuccess() {
    window.clearTimeout(staleTimer);
    state.successPending = true;
    staleTimer = window.setTimeout(() => {
      if (state.successPending) openBagAfterAdd();
      state.successPending = false;
    }, 1200);
  }

  function markAddIntent(event) {
    const button = event.target.closest?.('[data-atc-form]');
    if (button && state.pendingAdd?.button === button) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!button || button.disabled || button.dataset.artboxDeviceGate === 'true' || button.closest('[data-artbox-bag-editor]')) return;
    if (!button.closest('.artbox-product, [data-artbox-quick-shop]')) return;
    window.clearTimeout(staleTimer);
    state.successPending = true;
    staleTimer = window.setTimeout(() => {
      state.successPending = false;
      staleTimer = 0;
    }, 5000);
  }

  function completeSuccessfulAdd() {
    if (!state.successPending) return;
    window.clearTimeout(staleTimer);
    staleTimer = 0;
    state.successPending = false;
    if (state.editorActive) showBagList();
    openBagAfterAdd();
  }

  function reuseBagImages(html) {
    const loaded = new Map();
    const imageKey = (source) => {
      try {
        const url = new URL(source, window.location.href);
        if (!['http:', 'https:'].includes(url.protocol)) return null;
        // Only a width-only resize may reuse the already loaded original.
        // Preserve the origin, full path, version and every crop/format parameter.
        if (!url.searchParams.has('height')) url.searchParams.delete('width');
        url.searchParams.sort();
        url.hash = '';
        return url.href;
      } catch { return null; }
    };
    document.querySelectorAll('[data-artbox-gallery-panel] img, [data-artbox-quick-shop] .t4s-product__media img, #t4s-mini_cart .artbox-cart-item__image img').forEach((image) => {
      if (!image.complete || !image.naturalWidth) return;
      const source = image.currentSrc || image.src;
      const key = imageKey(source);
      if (key && !loaded.has(key)) loaded.set(key, source);
    });
    if (!loaded.size) return html;
    const template = document.createElement('template');
    template.innerHTML = html;
    let changed = false;
    template.content.querySelectorAll('.artbox-cart-item__image img').forEach((image) => {
      const source = loaded.get(imageKey(image.getAttribute('src')));
      if (!source) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
      changed = true;
    });
    return changed ? template.innerHTML : html;
  }

  async function renderAddedSections(sections) {
    const deadline = Date.now() + 12000;
    // Recover content while native scripts are loading; only rendering needs them.
    if (!sections?.cart_data || !sections?.mini_cart) {
      const response = await window.fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart_data,mini_cart`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to refresh your Bag.');
      sections = await response.json();
    }
    if (!sections?.cart_data || !sections?.mini_cart) throw new Error('Unable to refresh your Bag.');
    sections = { ...sections, mini_cart: reuseBagImages(sections.mini_cart) };
    while (!window.T4SThemeSP?.Cart?.renderContents || !window.T4SThemeSP?.Drawer) {
      if (Date.now() > deadline) throw new Error('Your item was added. Please open your Bag to review it.');
      await new Promise(resolve => window.setTimeout(resolve, 50));
    }
    if (!drawer?.querySelector('[data-cart-items]') && window.T4SThemeSP.Cart.hydrateInitialContents) {
      await window.T4SThemeSP.Cart.hydrateInitialContents(sections.mini_cart, sections.cart_data);
    }
    window.T4SThemeSP.isATCSuccess = true;
    state.successPending = true;
    window.jQuery_T4NT?.(document).trigger('add:cart:success').trigger('add:cart:upsell');
    window.T4SThemeSP.Cart.renderContents(sections);
  }

  function getFocusable(root) {
    return [...root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => element.getClientRects().length > 0);
  }

  function containFocus(event) {
    if (event.key !== 'Tab' || !drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    const focusable = getFocusable(drawer);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function focusBag() {
    if (state.checkoutOverlayOpen) return;
    drawer?.addEventListener('keydown', containFocus);
    if (state.inputMode !== 'keyboard') {
      window.requestAnimationFrame(() => document.activeElement?.blur?.());
      return;
    }
    const close = drawer?.querySelector('[data-drawer-close]');
    (isVisible(close) ? close : drawer)?.focus();
  }

  function returnBagFocus() {
    drawer?.removeEventListener('keydown', containFocus);
    showBagList();
    const fallback = [...document.querySelectorAll('[data-drawer-options*="#t4s-mini_cart"]')].find(isVisible);
    const target = state.lastBagOpener?.isConnected ? state.lastBagOpener : fallback;
    if (state.inputMode === 'keyboard') target?.focus();
    else target?.blur?.();
  }

  function drawerStateChanged() {
    if (drawer?.getAttribute('aria-hidden') === 'false') focusBag();
    else returnBagFocus();
  }

  function selectedOptions(root) {
    if (!root) return [];
    return [...root.querySelectorAll('[data-swatch-option]')].map((option) => ({
      name: option.dataset.artboxOptionName || option.querySelector('.t4s-swatch__title')?.textContent?.split(':')[0]?.trim(),
      value: option.querySelector('[data-swatch-item].is--selected')?.getAttribute('data-value')?.trim(),
    })).filter(({ name, value }) => name && value);
  }

  function restoreOptions(root, options) {
    for (const remembered of options) {
      const option = [...root.querySelectorAll('[data-swatch-option]')].find((candidate) => {
        const name = candidate.dataset.artboxOptionName || candidate.querySelector('.t4s-swatch__title')?.textContent?.split(':')[0]?.trim();
        return name?.toLowerCase() === remembered.name.toLowerCase();
      });
      const item = [...(option?.querySelectorAll('[data-swatch-item]') || [])].find((candidate) => (
        candidate.getAttribute('data-value')?.trim() === remembered.value
        && !candidate.classList.contains('is--soldout')
        && !candidate.classList.contains('is--unavailable')
      ));
      item?.click();
    }
  }

  function optionName(option) {
    return (option.dataset.artboxOptionName || option.querySelector('.t4s-swatch__title')?.textContent?.split(':')[0] || '').trim();
  }

  function hasNativeColorOption(root) {
    return [...root.querySelectorAll('[data-swatch-option]')].some((option) => {
      const name = optionName(option).toLowerCase().replace(/\s+/g, ' ');
      return ['color', 'colour', '颜色', '顏色', 'カラー', 'warna'].includes(name);
    });
  }

  function hydrateSwatchImages(root) {
    root.querySelectorAll('[data-swatch-item][data-bg]').forEach((item) => {
      const source = item.getAttribute('data-bg');
      if (!source) return;
      const imageUrl = new URL(source, window.location.href).href.replace(/"/g, '%22');
      item.style.backgroundImage = `url("${imageUrl}")`;
      item.classList.remove('lazyloadt4sing');
      item.classList.add('lazyloadt4sed');
    });
  }

  function placeLinkedColors(root) {
    const source = editor?.querySelector('[data-artbox-bag-editor-colors]');
    root.querySelectorAll('[data-artbox-bag-editor-colors-visual]').forEach((node) => node.remove());
    if (!source) return;
    source.hidden = true;
    if (hasNativeColorOption(root) || !source.querySelector('[data-artbox-linked-color]')) return;
    const visual = source.cloneNode(true);
    visual.removeAttribute('data-artbox-bag-editor-colors');
    visual.setAttribute('data-artbox-bag-editor-colors-visual', '');
    visual.hidden = false;
    visual.querySelector('[data-artbox-bag-linked-colors]')?.removeAttribute('hidden');
    const swatches = visual.querySelector('.artbox-linked-colors__swatches');
    const recordsNode = visual.querySelector('[data-artbox-linked-products]');
    let records = [];
    try { records = JSON.parse(recordsNode?.textContent || '[]'); } catch (_error) { records = []; }
    if (swatches && Array.isArray(records) && records.length) {
      const editUrl = new URL(state.editorTrigger?.href || window.location.href, window.location.origin);
      const selectedId = state.editorColorId
        || visual.querySelector('[data-artbox-linked-color][aria-pressed="true"]')?.dataset.artboxLinkedColor
        || records.find((record) => {
          if (!record.url) return false;
          const url = new URL(record.url, window.location.origin);
          return url.pathname === editUrl.pathname && (!url.searchParams.has('variant') || url.searchParams.get('variant') === editUrl.searchParams.get('variant'));
        })?.id
        || state.editorTrigger?.dataset.id;
      const buttons = records.map((record) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `artbox-linked-colors__swatch ${record.swatchClass || ''}`.trim();
        button.dataset.artboxLinkedColor = String(record.id);
        button.setAttribute('aria-label', record.colorName || record.title || 'Color');
        button.title = record.colorName || record.title || 'Color';
        button.setAttribute('aria-pressed', String(String(record.id) === String(selectedId)));
        if (record.swatchImage) button.style.setProperty('--artbox-swatch-image', `url("${String(record.swatchImage).replaceAll('"', '%22')}")`);
        else if (record.swatchColor) button.style.setProperty('--artbox-swatch-color', record.swatchColor);
        return button;
      });
      swatches.replaceChildren(...buttons);
    }
    const selected = visual.querySelector('[data-artbox-linked-color][aria-pressed="true"]');
    const title = document.createElement('div');
    title.className = 'artbox-bag-editor__color-title';
    title.textContent = `Color: ${selected?.getAttribute('aria-label') || ''}`.trim();
    visual.prepend(title);
    const summary = root.querySelector('.artbox-quick-shop__summary');
    const form = root.querySelector('.t4s-product-form__variants');
    if (summary) summary.after(visual);
    else if (form) form.before(visual);
  }

  function quickShopUrl(rawUrl) {
    const url = new URL(rawUrl, window.location.origin);
    url.searchParams.set('section_id', 'main-qs');
    return url;
  }

  async function loadEditorProduct(rawUrl, preserved = []) {
    refreshBagNodes();
    if (!editorContent) return;
    editorLabelObserver?.disconnect();
    editorLabelObserver = null;
    editor.dataset.artboxBagEditorState = 'loading';
    const response = await window.fetch(quickShopUrl(rawUrl), { headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' } });
    if (!response.ok) throw new Error(`Quick Shop request failed: ${response.status}`);
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const template = parsed.querySelector('template');
    const root = (template?.content || parsed).querySelector('[data-artbox-quick-shop]');
    if (!root) throw new Error('Quick Shop content missing');
    root.dataset.artboxBagEditorProduct = '';
    freezeBagHeight();
    const openingEditor = Boolean(list && !list.hidden);
    if (openingEditor) editor.style.removeProperty('--artbox-bag-image-offset');
    editorContent.replaceChildren(document.importNode(root, true));
    const mountedRoot = editorContent.querySelector('[data-artbox-quick-shop]');
    window.T4SThemeSP = window.T4SThemeSP || {};
    window.T4SThemeSP.isEditCartReplace = true;
    window.T4SThemeSP.iDVariantEdit = Number(state.editorTrigger?.dataset.id || 0);
    window.T4SThemeSP.keyVariantEdit = state.editorTrigger?.dataset.key || '';
    if (window.T4SThemeSP.Product && !mountedRoot.classList.contains('initProducts__enabled')) {
      mountedRoot.classList.add('initProducts__enabled');
      new window.T4SThemeSP.Product(mountedRoot);
    }
    window[Symbol.for('artbox.quickShop.lifecycle')]?.initialise(mountedRoot);
    restoreOptions(mountedRoot, preserved);
    hydrateSwatchImages(mountedRoot);
    placeLinkedColors(mountedRoot);
    const syncConfirmLabel = () => {
      const button = mountedRoot.querySelector('[data-atc-form]');
      const label = button?.querySelector('.t4s-btn-atc_text');
      if (button && label && !button.disabled && button.getAttribute('aria-disabled') !== 'true' && label.textContent.trim() !== 'Confirm') {
        label.textContent = 'Confirm';
      }
    };
    editorLabelObserver = new MutationObserver(syncConfirmLabel);
    editorLabelObserver.observe(mountedRoot, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, characterData: true, subtree: true });
    syncConfirmLabel();
    editor.dataset.artboxBagEditorState = 'ready';
    if (openingEditor) {
      list.hidden = true;
      editor.hidden = false;
      if (window.matchMedia('(max-width: 767px)').matches && Number.isFinite(state.editorImageTop)) {
        editor.scrollTop = 0;
        const media = mountedRoot.querySelector('.artbox-quick-shop__media');
        if (media) {
          const offset = state.editorImageTop - media.getBoundingClientRect().top;
          editor.style.setProperty('--artbox-bag-image-offset', `${offset}px`);
        }
      }
    }
    animateBagHeight();
    if (state.inputMode === 'keyboard') mountedRoot.querySelector('button, [href], input, select')?.focus();
  }

  function showBagEditor(trigger) {
    refreshBagNodes();
    if (!editor || !list) return;
    freezeBagHeight();
    state.editorActive = true;
    state.editorTrigger = trigger;
    state.editorImageTop = trigger.closest('[data-cart-item]')?.querySelector('.t4s-mini_cart__img')?.getBoundingClientRect().top ?? null;
    state.editorColorId = null;
    const linked = trigger.closest('[data-cart-item]')?.querySelector('[data-artbox-bag-linked-colors]');
    const slot = editor.querySelector('[data-artbox-bag-editor-colors]');
    if (slot) {
      slot.replaceChildren(...(linked ? [...linked.childNodes].map((node) => node.cloneNode(true)) : []));
      slot.querySelector('[data-artbox-bag-linked-colors]')?.removeAttribute('hidden');
      slot.hidden = true;
    }
    loadEditorProduct(trigger.href).catch((error) => {
      state.lastEditorError = error?.message || String(error);
      console.error('[Artbox Bag] Unable to load item editor', error);
      showBagList();
    });
  }

  async function resolveEditedItem() {
    const trigger = state.editorTrigger;
    if (!trigger) throw new Error('The item being edited is no longer available.');
    const url = `${window.Shopify?.routes?.root || '/'}cart.js`;
    const response = await window.fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to refresh your Bag. Please try again.');
    const cart = await response.json();
    let properties = {};
    try { properties = JSON.parse(trigger.dataset.artboxItemProperties || '{}') || {}; } catch (_error) { /* Empty properties are the native default. */ }
    const signature = (value) => JSON.stringify(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b)));
    const matches = (cart.items || []).filter((item) => (
      String(item.variant_id) === String(trigger.dataset.id)
      && signature(item.properties) === signature(properties)
      && String(item.selling_plan_allocation?.selling_plan?.id || '') === String(trigger.dataset.artboxItemSellingPlan || '')
    ));
    const exact = matches.find((item) => item.key === trigger.dataset.key);
    const quantityMatches = matches.filter((item) => String(item.quantity) === trigger.dataset.artboxItemQuantity);
    const item = exact || (matches.length === 1 ? matches[0] : quantityMatches.length === 1 ? quantityMatches[0] : null);
    if (!item) throw new Error('Your Bag changed. Please reopen the item and try again.');
    return { id: item.key };
  }

  function showBagList() {
    refreshBagNodes();
    const shouldAnimate = state.editorActive && canAnimateBagHeight();
    if (shouldAnimate) freezeBagHeight();
    editorLabelObserver?.disconnect();
    editorLabelObserver = null;
    state.editorActive = false;
    state.editorTrigger = null;
    state.editorImageTop = null;
    state.editorColorId = null;
    editor?.style.removeProperty('--artbox-bag-image-offset');
    if (list) list.hidden = false;
    if (editor) editor.hidden = true;
    if (editorContent) editorContent.replaceChildren();
    if (window.T4SThemeSP) window.T4SThemeSP.isEditCartReplace = false;
    if (shouldAnimate) animateBagHeight();
  }

  function handleEditorPointerDown(event) {
    if (event.button !== 0 || !drawer?.contains(event.target)) return;
    const edit = event.target.closest?.('[data-artbox-bag-edit]');
    if (!edit) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showBagEditor(edit);
  }

  function clearPendingAdd(restore = true) {
    const pending = state.pendingAdd;
    if (!pending) return;
    pending.observer.disconnect();
    window.clearTimeout(pending.timer);
    if (restore) {
      pending.button.removeAttribute('aria-busy');
      pending.button.removeAttribute('data-artbox-awaiting-product');
    }
    state.pendingAdd = null;
  }

  function handleEarlyAddPointerDown(event) {
    if (event.button !== 0) return;
    const button = event.target.closest?.('.artbox-product [data-atc-form]');
    const productRoot = button?.closest('[data-product-featured]');
    if (button && state.pendingAdd?.button === button) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (button?.closest('[data-artbox-product]')?.dataset.artboxPurchaseReady === 'true') return;
    if (!button || !productRoot || button.disabled || button.getAttribute('aria-disabled') === 'true'
      || productRoot.classList.contains('initProducts__enabled')) return;
    if (button.dataset.artboxDeviceGate === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    clearPendingAdd();
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('data-artbox-awaiting-product', '');
    const observer = new MutationObserver(() => {
      if (!productRoot.classList.contains('initProducts__enabled')) return;
      clearPendingAdd();
      window.requestAnimationFrame(() => {
        if (button.isConnected && productRoot.isConnected && !button.disabled
          && button.getAttribute('aria-disabled') !== 'true') button.click();
      });
    });
    observer.observe(productRoot, { attributes: true, attributeFilter: ['class'] });
    const timer = window.setTimeout(() => clearPendingAdd(), 6000);
    state.pendingAdd = { button, observer, timer };
  }

  function handleEditorKeyDown(event) {
    if (!['Enter', ' '].includes(event.key) || !drawer?.contains(event.target)) return;
    const edit = event.target.closest?.('[data-artbox-bag-edit]');
    if (!edit) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showBagEditor(edit);
  }

  function clearCheckoutRequest() {
    checkoutObserver?.disconnect();
    checkoutObserver = null;
    overlayObserver?.disconnect();
    overlayObserver = null;
    overlayDiscoveryObserver?.disconnect();
    overlayDiscoveryObserver = null;
    window.clearTimeout(checkoutTimer);
    checkoutTimer = 0;
    state.checkoutPending = false;
    state.checkoutTriggered = false;
    state.checkoutOverlayOpen = false;
    delete document.documentElement.dataset.artboxCheckoutOverlay;
    const button = drawer?.querySelector('[data-artbox-cart-buy-now]');
    button?.removeAttribute('aria-busy');
    if (button) button.disabled = false;
  }

  function syncCheckoutOverlay() {
    const modal = document.querySelector('#easysell-modal');
    const visible = Boolean(modal && modal.getClientRects().length && getComputedStyle(modal).display !== 'none');
    if (visible && !state.checkoutOverlayOpen) {
      state.checkoutOverlayOpen = true;
      document.documentElement.dataset.artboxCheckoutOverlay = 'open';
      window.clearTimeout(checkoutTimer);
      checkoutTimer = 0;
      drawer?.removeEventListener('keydown', containFocus);
      modal.querySelector('#easysell')?.focus({ preventScroll: true });
    } else if (!visible && state.checkoutOverlayOpen) {
      clearCheckoutRequest();
      if (drawer?.getAttribute('aria-hidden') === 'false') {
        drawer.addEventListener('keydown', containFocus);
        drawer.querySelector('[data-artbox-cart-buy-now]')?.focus({ preventScroll: true });
      }
    }
  }

  function watchCheckoutOverlay() {
    const attach = () => {
      const modal = document.querySelector('#easysell-modal');
      if (!modal || overlayObserver) return;
      overlayObserver = new MutationObserver(syncCheckoutOverlay);
      overlayObserver.observe(modal, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'] });
      syncCheckoutOverlay();
    };
    attach();
    overlayDiscoveryObserver = new MutationObserver(() => {
      attach();
      if (state.checkoutOverlayOpen && !document.querySelector('#easysell-modal')) syncCheckoutOverlay();
    });
    overlayDiscoveryObserver.observe(document.body, { childList: true });
  }

  function triggerCartCheckout() {
    if (state.checkoutTriggered) return true;
    const checkout = drawer?.querySelector('.es-popup-button-drawer:not([disabled]):not([aria-disabled="true"])');
    if (!checkout) return false;
    state.checkoutTriggered = true;
    checkoutObserver?.disconnect();
    checkoutObserver = null;
    watchCheckoutOverlay();
    checkout.click();
    return true;
  }

  function requestCartCheckout() {
    if (state.checkoutPending) return;
    state.checkoutPending = true;
    const button = drawer?.querySelector('[data-artbox-cart-buy-now]');
    button?.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    checkoutTimer = window.setTimeout(clearCheckoutRequest, 6000);
    if (triggerCartCheckout()) return;
    checkoutObserver = new MutationObserver(() => triggerCartCheckout());
    checkoutObserver.observe(drawer, { childList: true, subtree: true });
  }

  function handleCheckoutPointerDown(event) {
    if (event.button !== 0 || !event.target.closest?.('#t4s-mini_cart [data-artbox-cart-buy-now]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    requestCartCheckout();
  }

  function handleDrawerClick(event) {
    if (!drawer?.contains(event.target)) return;
    const edit = event.target.closest?.('[data-artbox-bag-edit]');
    if (edit) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (state.editorActive && edit === state.editorTrigger) return;
      showBagEditor(edit);
      return;
    }
    const color = event.target.closest?.('[data-artbox-bag-editor] [data-artbox-linked-color]');
    if (color) {
      const root = editorContent?.querySelector('[data-artbox-quick-shop]');
      const recordsNode = color.closest('[data-artbox-bag-editor]')?.querySelector('[data-artbox-linked-products]');
      let records = [];
      try { records = JSON.parse(recordsNode?.textContent || '[]'); } catch (_error) { records = []; }
      const record = records.find((candidate) => String(candidate.id) === color.dataset.artboxLinkedColor);
      if (record?.url) {
        state.editorColorId = record.id;
        editor.querySelectorAll('[data-artbox-linked-color]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.artboxLinkedColor === String(record.id)));
        });
        loadEditorProduct(record.url, selectedOptions(root));
      }
      return;
    }
    if (event.target.closest?.('[data-artbox-cart-buy-now]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      requestCartCheckout();
    }
  }

  function destroy() {
    window.clearTimeout(staleTimer);
    window.cancelAnimationFrame(bagHeightFrame);
    window.clearTimeout(bagHeightTimer);
    if (drawer) drawer.style.height = '';
    clearPendingAdd();
    clearCheckoutRequest();
    editorLabelObserver?.disconnect();
    editorLabelObserver = null;
    document.removeEventListener('pointerdown', notePointerInput, true);
    document.removeEventListener('keydown', noteKeyboardInput, true);
    document.removeEventListener('click', captureBagOpener, true);
    document.removeEventListener('click', markAddIntent, true);
    document.removeEventListener('cart:updated', completeSuccessfulAdd);
    window.removeEventListener('pointerdown', handleEditorPointerDown, true);
    window.removeEventListener('pointerdown', handleEarlyAddPointerDown, true);
    window.removeEventListener('pointerdown', handleCheckoutPointerDown, true);
    window.removeEventListener('keydown', handleEditorKeyDown, true);
    window.removeEventListener('click', handleDrawerClick, true);
    drawer?.removeEventListener('keydown', containFocus);
    drawerObserver?.disconnect();
    window.jQuery_T4NT?.(document).off('add:cart:success.artboxCart');
  }

  document.addEventListener('pointerdown', notePointerInput, true);
  document.addEventListener('keydown', noteKeyboardInput, true);
  document.addEventListener('click', captureBagOpener, true);
  document.addEventListener('click', markAddIntent, true);
  document.addEventListener('cart:updated', completeSuccessfulAdd);
  window.addEventListener('pointerdown', handleEarlyAddPointerDown, true);
  window.addEventListener('pointerdown', handleCheckoutPointerDown, true);
  window.addEventListener('pointerdown', handleEditorPointerDown, true);
  window.addEventListener('keydown', handleEditorKeyDown, true);
  window.addEventListener('click', handleDrawerClick, true);
  window.jQuery_T4NT?.(document).off('add:cart:success.artboxCart').on('add:cart:success.artboxCart', markAddSuccess);

  if (drawer) {
    refreshBagNodes();
    drawerObserver = new MutationObserver(drawerStateChanged);
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    if (drawer.getAttribute('aria-hidden') === 'false') drawer.addEventListener('keydown', containFocus);
  }

  window.ArtboxCartExperience = { destroy, openBag, showBagList, resolveEditedItem, renderAddedSections, state };
})();
